import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import "./styles/tokens.css";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <AdminAuthProvider>
      <App />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar newestOnTop />
    </AdminAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
